<template>
  <div class="flex flex-col" :class="{ 'cursor-wait': downloadLoading }">
    <div
      class="py-4 px-6 flex items-center justify-between border-b border-slate-400"
    >
      <BlTextSubtitle2 text="Download report as PDF" class="text-slate-700" />
      <BlIcon
        icon="close"
        class="h-6 w-6"
        clickable
        @clicked="$emit('close')"
      />
    </div>
    <div class="py-4 px-6 flex flex-col gap-3">
      <BlTextBody2
        text="Download your report as a PDF for easy sharing or offline review. Click the button below to generate the PDF file."
      />
      <div v-if="downloadLoading" class="h-16 grid place-items-center">
        <div class="blum-loader-btn"></div>
      </div>
      <BlInputButton
        label="Download as PDF"
        type="outlined"
        :loading="downloadLoading"
        @clicked="onDownload"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "DownloadReport",
  components: {
    BlTextSubtitle2,
    BlTextBody2,
    BlInputButton,
    BlIcon
  },
  props: {
    // @close
  },
  data() {
    return {
      downloadLoading: false
    };
  },
  computed: {
    ...mapGetters(["report"])
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(["downloadReports"]),
    onDownload() {
      this.downloadLoading = true;
      const data = {
        ids: [this.report.id]
      };
      this.downloadReports(data)
        .then(res => {
          const href = URL.createObjectURL(res.data);

          // generate filename
          function getFormattedTime() {
            const today = new Date();
            const y = today.getFullYear();
            // JavaScript months are 0-based.
            const m = today.getMonth() + 1;
            const d = today.getDate();
            const h = today.getHours();
            const mi = today.getMinutes();
            const s = today.getSeconds();
            return `${y}${m}${d}T${h}${mi}${s}`;
          }
          const reportName = this.report ? this.report.name : "report";
          const clientName = this.report ? this.report.client_name : "client";
          const suffix = getFormattedTime();
          const filename = `${clientName}_${reportName}_${suffix}.pdf`;

          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          this.downloadLoading = false;
        })
        .catch(err => {
          console.error(err);
          this.downloadLoading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/reports/helper/DownloadReport.vue